/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Dataroom_Addmodal_Title3Inputs */

const en_coinvestments_dataroom_addmodal_title3 = /** @type {(inputs: Coinvestments_Dataroom_Addmodal_Title3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add data room`)
};

/**
* | output |
* | --- |
* | "Add data room" |
*
* @param {Coinvestments_Dataroom_Addmodal_Title3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_dataroom_addmodal_title3 = /** @type {((inputs?: Coinvestments_Dataroom_Addmodal_Title3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Dataroom_Addmodal_Title3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_dataroom_addmodal_title3(inputs)
});
export { coinvestments_dataroom_addmodal_title3 as "coInvestments_dataRoom_addModal_title" }